import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateGroupe } from '../api/GROUPES/groupes';
import { toast } from 'react-toastify';

export const useUpdateGroupe = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ groupeId, groupeData }) => updateGroupe(groupeId, groupeData),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['groupes'] });
            toast.success('Groupe modifié avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la modification du groupe');
        },
    });
};
